module.exports = __webpack_public_path__ + "src/images/measurements/ankleCircumference.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/ankleCircumference.jpg
// module id = 1139
// module chunks = 0